"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/ToastsScreen/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _hooks = require('web/services/hooks');
var _user = require('shared/selectors/user');
var _app = require('shared/selectors/app');
var _app3 = require('web/services/app');
var _Toasts = require('web/components/Toasts');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);

const TOASTS = {
  netInfo: 'NET_INFO_TOAST',
  appDownload: 'DESKTOP_UPDATE_TOAST',
  appUpdate: 'APP_UPDATE_TOAST',
}

// memo keeps connect()'s bailout on parent re-renders.
const ToastsScreen = _react.memo.call(void 0, function ToastsScreen () {
  const isOnline = _hooks.useAppSelector.call(void 0, _app.selectIsAppOnline)
  const isLoggedIn = _hooks.useAppSelector.call(void 0, _user.selectIsUserLoggedIn)
  const isAppOutdated = _hooks.useAppSelector.call(void 0, _app.selectIsAppOutdated)
  const isDownloadAvailable = _hooks.useAppSelector.call(void 0, _app.selectIsDownloadAvailable)

  const activeToast = _react.useMemo.call(void 0, 
    () => {
      if (isLoggedIn && !isOnline) return TOASTS.netInfo
      if (isDownloadAvailable) return TOASTS.appDownload
      if (isAppOutdated) return TOASTS.appUpdate
    },
    [isLoggedIn, isOnline, isDownloadAvailable, isAppOutdated],
  )

  _react.useEffect.call(void 0, 
    () => {
      if (activeToast === TOASTS.appDownload) _amplitude2.default.logEvent(TOASTS.appDownload)
      else if (activeToast === TOASTS.appUpdate) _amplitude2.default.logEvent(TOASTS.appUpdate)
    },
    [activeToast],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Toasts.NetInfoToast, {
        isOnStage: activeToast === TOASTS.netInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
      , _react2.default.createElement(_Toasts.AppDownloadToast, {
        isOnStage: activeToast === TOASTS.appDownload,
        onDownload: _app3.downloadApp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      )
      , _react2.default.createElement(_Toasts.AppUpdateToast, {
        isOnStage: activeToast === TOASTS.appUpdate,
        onUpdate: _app3.updateApp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
      )
    )
  )
})

exports. default = ToastsScreen
